import { Div } from "@tblabs/truffle";
import { AdminStepPrinter } from "../Components/AdminStepPrinter";
import { Order } from "../Models/Order";
import { StepsPrinter } from "./StepsPrinter";
import { Router } from "./Router";
import { AgentsProvider } from "./AgentsProvider";


export class OrderAsStepsPrinter extends Div
{
    constructor(_router: Router, _agents: AgentsProvider, order: Order)
    {
        super();

        this.Append(
            new StepsPrinter(order.Steps.Items, "admin", (step) => new AdminStepPrinter(_router, _agents, step), false)
        );
    }
}
